<template>
  <router-link v-bind="linkProps">
    <slot />
  </router-link>
</template>

<script setup>
import { computed } from 'vue';
import { RouterLink, useRoute } from 'vue-router';

const props = defineProps({
  ...RouterLink.props,
});

const route = useRoute();

const staticParams = {};
if (route.query._profile_id && route.query._profile_type) {
  staticParams._profile_id = route.query._profile_id;
  staticParams._profile_type = route.query._profile_type;
}

const linkProps = computed(() => {
  const to = props.to;

  if (typeof to === 'object') {
    return {
      ...props,
      to: {
        ...to,
        query: {
          ...staticParams,
          ...to.query,
        },
      },
    };
  }

  return props;
});
</script>
